import { ImmediateRigidBodyBundleImpl } from "./Immediate/immediateRigidBodyBundleImpl";
import { ImmediateRigidBodyImpl } from "./Immediate/immediateRigidBodyImpl";
class NullSpinlock {
    wait() { }
}
/**
 * Empty implementation of the physics runtime
 * for use PhysicsWorld/MultiPhysicsWorld directly without any additional runtime
 */
export class NullPhysicsRuntime {
    /**
     * @internal
     */
    wasmInstance;
    /**
     * Spinlock for the physics runtime to synchronize access to the physics world state
     * @internal
     */
    lock;
    /**
     * Creates a new physics runtime
     * @param wasmInstance The Bullet WASM instance
     */
    constructor(wasmInstance) {
        this.wasmInstance = wasmInstance;
        this.lock = new NullSpinlock();
    }
    /** @internal */
    createRigidBodyImpl() {
        return new ImmediateRigidBodyImpl();
    }
    /** @internal */
    createRigidBodyBundleImpl(bundle) {
        return new ImmediateRigidBodyBundleImpl(bundle.count);
    }
}
